var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSiteCompass = function SvgSiteCompass(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2247",
    "data-name": "Group 2247",
    transform: "translate(-14114 8111)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2250",
    "data-name": "Rectangle 2250",
    width: 23,
    height: 23,
    transform: "translate(14114 -8111)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "location-arrow-solid",
    d: "M25.069,61.329a1.078,1.078,0,0,1-1.2.65,1.105,1.105,0,0,1-.9-1.057V55H17.043a1.077,1.077,0,0,1-.378-2.073l11.847-4.847a1.077,1.077,0,0,1,1.4,1.4Z",
    transform: "translate(14070.35 -8120.529) rotate(-45)",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSiteCompass, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/site-compass.e591ea29.svg";
export { ForwardRef as ReactComponent };